export const RESOURCE = 'adminmembership';
export const ACTIONS = { Create: '', Activate: '', Lock: '/lock', Unlock: '/unlock' }